import React, { useRef } from 'react';
import { collection, doc, getDocs, deleteDoc, writeBatch } from 'firebase/firestore';
import { db } from '../../firebase';

const DeleteSelected = ({
  selectedIDs,       // 삭제할 문서 ID 배열
  documents,         // 전체 문서 데이터 배열 (예: albums 또는 activities)
  collectionPath,    // 삭제할 문서가 속한 컬렉션 경로 (예: `users_data/${userID}/activity`)
  itemName = "항목", // 표시용 이름 (예: "활동" 또는 "앨범")
  subcollections = [], // 삭제 시 함께 삭제할 하위 컬렉션 이름 배열 (예: ["tracks"])
  onDeleteSuccess,   // 삭제 성공 후 호출할 콜백
  fetchData,         // 삭제 후 데이터를 다시 불러올 함수
  setOpenPopup,
  setButtonLoading,
  setPopupTitle,
  setPopupFunction,
  setPopupButtonText
  }) => {

  const isSubmitting = useRef(false);

  const deleteDocumentWithSubcollections = async (collectionPath, id, subcollections = []) => {
    const docRef = doc(db, collectionPath, id);
  
    for (const subCol of subcollections) {
      const subColRef = collection(db, collectionPath, id, subCol);
      const subDocsSnapshot = await getDocs(subColRef);
  
      const deleteSubPromises = subDocsSnapshot.docs.map((subDoc) => deleteDoc(subDoc.ref));
      await Promise.all(deleteSubPromises);
    }
  
    await deleteDoc(docRef); // 마지막에 상위 문서 삭제
  };

  const openDeletePopup = async () => {
    if (selectedIDs.length === 0) {
      setOpenPopup(true);
      setPopupTitle(`삭제할 ${itemName}를 선택하세요.`);
      setPopupButtonText('');
      setPopupFunction('');
      return;
    } else {
      // 선택한 문서 중 act 필드가 비어있지 않은 경우가 있는지 확인
      const docsToDelete = documents.filter(doc => selectedIDs.includes(doc.id));
      const hasConnectedMusicard = docsToDelete.some(
        (docData) => docData.act && Object.keys(docData.act).length > 0
      );

      if (hasConnectedMusicard) {
        setOpenPopup(true);
        setPopupTitle(`해당 ${itemName}은 뮤지카드에 연결되어 있습니다. <br/>모든 뮤지카드에서 해당 ${itemName}을 삭제한 후 다시 시도해 주세요.`);
        setPopupButtonText('');
        setPopupFunction('');
        return;
      } else {
        setOpenPopup(true);
        setPopupTitle(`선택한 ${itemName}를 삭제하시겠습니까?`);
        setPopupButtonText('삭제');
        setPopupFunction(() => handleDelete);

        return;
      }
    }
  };
  const handleDelete = async () => {
    try {
      if (isSubmitting.current) return; // 실행 중일 경우 중복 클릭 방지
      isSubmitting.current = true;      // 버튼 비활성화
      setButtonLoading(true);           // 버튼 로딩 표시
      
      // 각 선택된 문서에 대해 삭제 진행
      const deletePromises = selectedIDs.map((id) =>
        deleteDocumentWithSubcollections(collectionPath, id, subcollections)
      );
      await Promise.all(deletePromises);      

      isSubmitting.current = false; // 버튼 활성화
      setButtonLoading(false);      // 버튼 로딩 숨김

      setOpenPopup(true);
      setPopupTitle(`선택한 ${itemName}이(가) 삭제되었습니다.`);
      setPopupButtonText('');
      setPopupFunction('');

      onDeleteSuccess();
      fetchData();
    } catch (error) {
      isSubmitting.current = false; // 버튼 활성화
      setButtonLoading(false);      // 버튼 로딩 숨김
      console.error(`${itemName} 삭제 오류:`, error);

      setOpenPopup(true);
      setPopupTitle(`${itemName} 삭제 중 오류가 발생했습니다.`);
      setPopupButtonText('');
      setPopupFunction('');
    }
  };

  return (
    <>
      <div className={`commonButton fullwidth ${selectedIDs.length ? '' : 'hidden'}`}>
        <button className="secondary" onClick={ openDeletePopup }>삭제</button>
      </div>
    </>
  );
};

export default DeleteSelected;